import React from 'react'
import { useColorMode } from 'theme-ui'
import { useStaticQuery, graphql } from 'gatsby'
import { getImage } from 'gatsby-plugin-image'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import Logo from '@components/Logo'
import useSiteMetadata from '@helpers-blog/useSiteMetadata'

export const HeaderLogo = ({ logoType = '', ...props }) => {
  const { title } = useSiteMetadata()
  const breakpoints = useBreakpoint()

  const [colorMode] = useColorMode()
  const isDark = colorMode === `dark`

  const { logo, logoDark, footerLogo, footerLogoDark } =
    useStaticQuery(logoQuery)

  const logoNormal = getImage(logo)
  const LogoDark = getImage(logoDark)
  const footerNormal = getImage(footerLogo)
  const footerDark = getImage(footerLogoDark)

  if (!logoNormal) return null

  if (isDark && LogoDark) {
    if (logoType === 'footer') {
      return <Logo image={footerDark} title={title} alt={title} {...props} />
    } else {
      return (
        <Logo
          image={breakpoints.sm ? LogoDark : footerDark}
          title={title}
          alt={title}
          {...props}
        />
      )
    }
  } else {
    if (logoType === 'footer') {
      return <Logo image={footerNormal} title={title} alt={title} {...props} />
    } else {
      return (
        <Logo
          image={breakpoints.sm ? logoNormal : footerNormal}
          title={title}
          alt={title}
          {...props}
        />
      )
    }
  }
}

const logoQuery = graphql`
  query LogoQuery {
    logo: file(
      absolutePath: {
        regex: "/cfit-logo-brown-square-light.(jpeg|jpg|gif|png)/"
      }
      sourceInstanceName: { eq: "asset" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width:52
          layout: CONSTRAINED
          quality: 100
          placeholder: NONE
        )
      }
    }
    logoDark: file(
      absolutePath: {
        regex: "/cfit-logo-brown-square-dark.(jpeg|jpg|gif|png)/"
      }
      sourceInstanceName: { eq: "asset" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width:52
          layout: CONSTRAINED
          quality: 100
          placeholder: NONE
        )
      }
    }

    footerLogo: file(
      absolutePath: {
        regex: "/cfit-logo-brown-horizontal-light01.(jpeg|jpg|gif|png)/"
      }
      sourceInstanceName: { eq: "asset" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width: 310
          layout: CONSTRAINED
          quality: 100
          placeholder: NONE
        )
      }
    }
    footerLogoDark: file(
      absolutePath: {
        regex: "/cfit-logo-brown-horizontal-dark01.(jpeg|jpg|gif|png)/"
      }
      sourceInstanceName: { eq: "asset" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width: 310
          layout: CONSTRAINED
          quality: 100
          placeholder: NONE
        )
      }
    }
  }
`
